import { FC, useEffect } from 'react';
import { isIOS } from 'react-device-detect';
import { Loader } from 'components';
import { WebviewFunctions } from 'constants/common';

const AppStoreRedirectWebViewPage: FC = () => {
  const appStoreUrl = 'https://apps.apple.com/us/app/scanpay-accept-payments/id1572936786';
  const playStoreUrl = 'https://play.google.com/store/apps/details?id=tech.scanpay.merchant';

  useEffect(() => {
    if (window?.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview.callHandler(WebviewFunctions.WEBVIEW_LOADED);
    }
    let redirectUrl: string;
    if (isIOS) {
      redirectUrl = appStoreUrl;
    } else {
      redirectUrl = playStoreUrl;
    }

    window.location.href = redirectUrl;

    if (window?.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview.callHandler(WebviewFunctions.CLOSE_WEBVIEW_CHECKOUT);
    }
  }, []);

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <Loader />
    </div>
  );
};

export default AppStoreRedirectWebViewPage;
